if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const targetMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${targetMediaId}"]`);
        if (!activeMedia) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          const isActive = element.getAttribute('data-media-id') === targetMediaId;
          element.classList.toggle('active', isActive);
          if (this.classList.contains('product-media-modal--clone')) {
            element.hidden = !isActive;
          }
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
